import React from "react";

const ReportsSVG = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="11.333"
      height="8.5"
      viewBox="0 0 11.333 8.5"
    >
      <path
        id="chart-bar-solid"
        d="M7.367,69.667h.85a.3.3,0,0,0,.283-.283V66.408a.3.3,0,0,0-.283-.283h-.85a.3.3,0,0,0-.283.283v2.975A.3.3,0,0,0,7.367,69.667Zm2.125,0h.85a.3.3,0,0,0,.283-.283v-5.1A.3.3,0,0,0,10.342,64h-.85a.3.3,0,0,0-.283.283v5.1A.3.3,0,0,0,9.492,69.667Zm-6.375,0h.85a.3.3,0,0,0,.283-.283V67.825a.3.3,0,0,0-.283-.283h-.85a.3.3,0,0,0-.283.283v1.558A.3.3,0,0,0,3.117,69.667Zm2.125,0h.85a.3.3,0,0,0,.283-.283V64.992a.3.3,0,0,0-.283-.283h-.85a.3.3,0,0,0-.283.283v4.392A.3.3,0,0,0,5.242,69.667Zm5.738,1.417H1.417V64.354A.354.354,0,0,0,1.063,64H.354A.354.354,0,0,0,0,64.354v7.437a.708.708,0,0,0,.708.708H10.979a.354.354,0,0,0,.354-.354v-.708A.354.354,0,0,0,10.979,71.083Z"
        transform="translate(0 -64)"
        fill="#7599fa"
      />
    </svg>
  );
};

export default ReportsSVG;
